module.exports = __webpack_public_path__ + "img/popularize_banner02.44045288.png";